import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

class ReportMissingAddress extends Component {
    render() {
        const { address, email, t } = this.props
        const addressString = `${address.streetName} ${address.streetNo} ${address.zip} ${address.city}`
        return (
            <a
                className="report-missing-address"
                href={`mailto:${email}?subject=${t('reportAddressMailSubject', {
                    address: addressString,
                })}&body=${t('reportAddressMailBody', { address: addressString })}`}
            >
                {t('reportAddressMailLink')}
            </a>
        )
    }
}

ReportMissingAddress.propTypes = {
    address: PropTypes.object,
    email: PropTypes.string,
    t: PropTypes.func,
}

function mapStateToProps({ address }) {
    return {
        address: address.active,
        email: process.env.SUPPORT_EMAIL,
    }
}

export default connect(mapStateToProps)(withTranslation()(ReportMissingAddress))
